module.exports = __webpack_public_path__ + "static/media/branding_1080p_tl.80bf4a65.png";